<div id="documentPreviewContainer" class="flexColumnContainer">
  <div id="metadataPreview">
    @if (collaboratorHelperService.isCollaboratorView && documentHal.formIdentifier && !documentHal.hasFileId()) {
      <app-collaborator-preview-form-metadata class="flexColumnContainer collaborator-views" [documentHal]="documentHal"
      ></app-collaborator-preview-form-metadata>
    }
    @if (collaboratorHelperService.isCollaboratorView && documentHal.hasFileId()) {
      <app-collaborator-preview-pdf-metadata class="flexColumnContainer collaborator-views"
                                             [(documentHal)]="documentHal"
      ></app-collaborator-preview-pdf-metadata>
    }
    @if (!collaboratorHelperService.isCollaboratorView && documentHal.formIdentifier && !documentHal.hasFileId()) {
      <app-preview-form-metadata [documentHal]="documentHal"
      ></app-preview-form-metadata>
    }
    @if (!collaboratorHelperService.isCollaboratorView && documentHal.hasFileId()) {
      <app-preview-document-metadata [documentHal]="documentHal"
      ></app-preview-document-metadata>
    }
  </div>
  <div id="contentPreview">
    @if (documentHal.formIdentifier && !documentHal.hasFileId()) {
      <app-preview-form [document]="documentHal"
      ></app-preview-form>
    }
    @if (documentHal.hasFileId()) {
      <app-preview-document [document]="documentHal"
      ></app-preview-document>
    }
  </div>
</div>
